<template>
  <div class="row steps justify-content-center">
    <div class="col-11 col-md-9">
      <div class="row steps">
        <div class="col" :class="{ active: screen >= 1 }" @click="$emit('goToScreen',1)">20%<span></span></div>
        <div class="col" :class="{ active: screen >= 2 }" @click="$emit('goToScreen',2)">40%<span></span></div>
        <div class="col" :class="{ active: screen >= 3 }" @click="$emit('goToScreen',3)">60%<span></span></div>
        <div class="col" :class="{ active: screen >= 4 }" @click="$emit('goToScreen',4)">80%<span></span></div>
        <div class="col" :class="{ active: screen >= 5 }" @click="$emit('goToScreen',5)">100%<span></span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: ['screen']
}
</script>
